// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".badge {\n  height: 1rem;\n  min-width: 1rem;\n  line-height: 1rem;\n  color: white;\n  font-size: 10px;\n  font-weight: 500;\n  text-align: center;\n  letter-spacing: -0.02em;\n  background-color: #f72585;\n  padding: 0px 4px;\n  border-radius: 1rem;\n  margin-left: 3px;\n  margin-bottom: -1px; }\n", ""]);
// Exports
module.exports = exports;



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader/dist/cjs.js!../node_modules/sass-loader/lib/loader.js!./Src/Containers/Chat/Badge.scss
// module id = 1810
// module chunks = 1